import styled from 'styled-components';

export const StyledPlayVideo = styled.div`
  cursor: pointer;

  img {
    width: 12rem;
    transition: .5s linear;
    scale: 1.0;

    &:hover {
      transform: rotate(360deg);
      scale: 1.1;
    }
  }
`;
